import './ModalConfirm.scss'

import React from 'react';

import Modal from 'react-modal';
import ModalButton from 'components/ModalButton';

import H3 from 'components/H3';

import { MODAL_STYLE_RESET } from 'utils/constants';

export default class ModalConfirm extends React.Component {
    static propTypes = {
        cancelAction: React.PropTypes.func,
        cancelText: React.PropTypes.string,
        className: React.PropTypes.string,
        confirmAction: React.PropTypes.func.isRequired,
        confirmText: React.PropTypes.string,
        disabled: React.PropTypes.bool,
        show: React.PropTypes.bool.isRequired,
        text: React.PropTypes.string.isRequired
    };

    render() {
        let { cancelAction, cancelText, className, confirmAction, confirmText, disabled, show, text, title } = this.props;
        let styles = JSON.parse(JSON.stringify(MODAL_STYLE_RESET));
        styles.overlay.zIndex = 102;
        return (
            <Modal isOpen={show}
                   style={styles}
                   className={`confirm-modal ${className || ''}`}
                   contentLabel="Modal"
                   onRequestClose={this._handleClose}>
                <div className="confirm-modal--inner">
                    <H3 className="modal__title">
                        {title}
                    </H3>
                    {text != null ? (
                        <div className="modal__text">
                            {text}
                        </div>
                    ) : null}
                    <div className="modal__content">
                        <div className="modal__buttons">
                            <ModalButton icon="check"
                                         disabled={disabled}
                                         onClick={confirmAction.bind(this)}
                                         text={confirmText || 'Confirm'} />
                            {cancelAction != null ? (
                                <ModalButton icon="cancel"
                                             disabled={disabled}
                                             onClick={cancelAction.bind(this)}
                                             text={cancelText || 'Cancel'} />
                            ) : null}
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalConfirm/index.js